const clinicNameOverrides = {
  14165: {
    locationName: ''
  },
  14166: {
    locationName: ''
  },
  14210: {
    locationLabel: 'ANN ARBOR, MI'
  },
  14220: {
    locationName: '',
    locationLabel: 'BROWNSTOWN, MI'
  }
};

export default function clinicOverrideName(clinicId) {
  return clinicNameOverrides[clinicId] || null;
}
